import React from "react";
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import './tele.styles.css';
const TeleServices = () => {
  return (
    <>
      <div className="header2">
        <Header></Header>
        <section class="inner-banner services-banner">
          <div class="container h-100">
            <div class="inner-caption">
              <h2>Telecommunication Services<br></br> 
              <p className="mb-0 text-center">( Coming Soon )</p></h2>
            </div>
          </div>
        </section>
        <div className="container">
          <div class="services-listing-wrapper">
            <ul>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/home-doctor.png")} alt="home-doctor" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Doctor for Home Visit</h2>
                    <p>Dawa Asaan team of qualified specialist and medical officers visit patients in the comfort of their home for treatment.</p>
                  </a>
                </div>
              </li>
              <li>
                <div class="service-box">
                  <span class="icon">
                    <img src={require("../../assets/images/doctor-call.png")} alt="doctor-call" class="img-fluid" />
                  </span>
                  <a>
                    <h2>Doctor on Call</h2>
                    <p>Our consultants and doctors are available on telephone, video and audio consultation for patient’s consultation.</p>
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <section class="sectionspace80 bookingsection">
          <div class="container">
            <div class="heading-title">
              <h2>Download Dawa Asaan App Now!</h2>
            </div>
            <div class="row pt-md-4 align-items-center justify-content-center  mx-0 mx-md-row px-2 px-md-0">
              <div class="col-12 col-md-4">
                <figure class="mobileapp_img_holder position-relative mx-auto mb-3 mb-md-2">
                  <img class="mobileapp_img img-fluid" src={require("../../assets/images/mobile-img-3.png")} alt="mobile app Dawa Asaan" />
                </figure>
              </div>
              <div class="col-12 col-md-5 pb-4 text_center_mobile">
                <p class="mb-3">Avail best quality health care services on click of a button.</p>
                <a href="https://apps.apple.com/pk/app/dawa-asaan/id1528679507" target="_blank" class="mr-2"><img src={require("../../assets/images/ios.png")} /></a>
                <a href="https://play.google.com/store/apps/details?id=com.novatorsols.dawaasaan" target="_blank" class="mr-2"><img src={require("../../assets/images/google.png")} /></a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer></Footer>
    </>
  )
}
export default TeleServices;